'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { MouseEvent } from 'react';
import { dataLayerPush, getBaseUrlJoined, trackMainNavLinkClick } from '@libs/analytics';
import { usePageLayout } from '@libs/common-next';
import { handleServiceClick } from '@libs/experience-api';
import type { Card } from '../card-up/types';
import { MarketingSection } from './MarketingSection';
import { MenuCard } from './MenuCard';
import { RecursiveMenu } from './RecursiveMenu';
import { TabbedMenu } from './TabbedMenu';
import type { CategoryTypes, SubMenuProps } from './types';
import { getCategoryPath, trackCategoryPath, trackingData } from './utils';
import { shouldRenderSubMenu } from './utils/shouldRenderSubMenu';
function RenderMenuType(t0) {
  const $ = _c(23);
  const {
    type,
    mappedCategory,
    parentCategory,
    path
  } = t0;
  const {
    isAuthenticated,
    isSoftAuthenticated
  } = usePageLayout();
  const {
    cards,
    categories,
    displayText,
    link,
    rightMenuCard,
    specialType
  } = mappedCategory;
  let t1;
  if ($[0] !== displayText || $[1] !== isAuthenticated || $[2] !== isSoftAuthenticated || $[3] !== link || $[4] !== path) {
    t1 = function handleOnClick(event) {
      handleServiceClick({
        authType: isAuthenticated,
        event,
        link,
        isSoftAuthenticated
      });
      const categoryPath = getCategoryPath(path, displayText);
      const categoryPathTrack = trackCategoryPath(categoryPath);
      trackMainNavLinkClick(categoryPathTrack);
      dataLayerPush(trackingData({
        selection: categoryPathTrack,
        link_url: getBaseUrlJoined(link)
      }));
    };
    $[0] = displayText;
    $[1] = isAuthenticated;
    $[2] = isSoftAuthenticated;
    $[3] = link;
    $[4] = path;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOnClick = t1;
  switch (type) {
    case "tabs":
      {
        let t2;
        if ($[6] !== categories || $[7] !== parentCategory || $[8] !== path) {
          t2 = categories ? <TabbedMenu parentCategories={categories} parentCategory={parentCategory} path={path} /> : null;
          $[6] = categories;
          $[7] = parentCategory;
          $[8] = path;
          $[9] = t2;
        } else {
          t2 = $[9];
        }
        return t2;
      }
    case "card":
      {
        let t2;
        if ($[10] !== cards || $[11] !== displayText || $[12] !== handleOnClick || $[13] !== link || $[14] !== parentCategory || $[15] !== path) {
          t2 = cards ? <><ul className={`submenu-container__list card-list ${cards.length < 6 ? "larger-cards" : ""}`}>{cards.map(card => <MenuCard category={parentCategory} card={card} key={card.header} onClick={() => {
                trackMainNavLinkClick([...path, card.header].join(" | "));
              }} />)}</ul>{link && <Link data-testid="service-link" href={link} onClick={handleOnClick} prefetch={false}>{displayText}{" >"}</Link>}</> : null;
          $[10] = cards;
          $[11] = displayText;
          $[12] = handleOnClick;
          $[13] = link;
          $[14] = parentCategory;
          $[15] = path;
          $[16] = t2;
        } else {
          t2 = $[16];
        }
        return t2;
      }
    default:
      {
        let t2;
        if ($[17] !== categories || $[18] !== parentCategory || $[19] !== path || $[20] !== rightMenuCard || $[21] !== specialType) {
          t2 = categories ? <><ul className="submenu-container__list"><RecursiveMenu parentCategory={parentCategory} parentCategories={categories} path={path} wrapListItems={false} /></ul><MarketingSection rightMenuCard={rightMenuCard} childCategories={categories} specialType={specialType} path={path} /></> : null;
          $[17] = categories;
          $[18] = parentCategory;
          $[19] = path;
          $[20] = rightMenuCard;
          $[21] = specialType;
          $[22] = t2;
        } else {
          t2 = $[22];
        }
        return t2;
      }
  }
}
export function SubMenu(t0) {
  const $ = _c(15);
  const {
    mappedCategory,
    type,
    specialType,
    parentCategory,
    path: t1,
    menuDropdownStyle: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const path = t3;
  const menuDropdownStyle = t2 === undefined ? false : t2;
  const shouldRender = shouldRenderSubMenu(mappedCategory, type);
  if (!shouldRender) {
    return null;
  }
  let t4;
  if ($[2] !== specialType) {
    t4 = specialType?.toLowerCase().replaceAll(" ", "-") || "";
    $[2] = specialType;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `submenu-container ${t4}${menuDropdownStyle ? " narrow" : ""}`;
  const t6 = `submenu__layout submenu__layout--${type}`;
  let t7;
  if ($[4] !== mappedCategory || $[5] !== parentCategory || $[6] !== path || $[7] !== type) {
    t7 = <RenderMenuType {...{
      type,
      mappedCategory,
      parentCategory,
      path
    }} />;
    $[4] = mappedCategory;
    $[5] = parentCategory;
    $[6] = path;
    $[7] = type;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <div className={t6} data-testid="submenu-navigation">{t7}</div>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <div className={t5}>{t8}</div>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}